import { motion } from 'framer-motion';
import { Card, useColorModeValue } from '@chakra-ui/react';

const MotionCard = motion(Card);

/**
 * Animated card with hover effects
 * Can be used as a drop-in replacement for Chakra Card
 */
export function AnimatedCard({
  children,
  hoverScale = 1.02,
  hoverY = -4,
  enableHover = true,
  delay = 0,
  ...props
}) {
  const shadowColor = useColorModeValue(
    'rgba(0, 0, 0, 0.1)',
    'rgba(0, 0, 0, 0.3)'
  );

  const hoverProps = enableHover
    ? {
        whileHover: {
          y: hoverY,
          scale: hoverScale,
          boxShadow: `0 20px 25px -5px ${shadowColor}, 0 10px 10px -5px ${shadowColor}`,
        },
        whileTap: {
          scale: 0.98,
        },
      }
    : {};

  return (
    <MotionCard
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.4,
        delay,
        ease: [0.4, 0, 0.2, 1],
      }}
      {...hoverProps}
      style={{
        cursor: enableHover ? 'pointer' : 'default',
      }}
      {...props}
    >
      {children}
    </MotionCard>
  );
}
